<form #options="ngForm" class="page-fix-form-marquee-options">
    <div class="px-4 py-6">
        <h2 class="mt-0" translate>Repair options</h2>

        <div class="mb-4">
            <p class="text-bold mb-1" translate>Preview</p>
            <p class="inline-block my-0 preview">
                &lt;{{getElementText()}}&gt;<span [innerHTML]="previewText"></span>&lt;/{{getElementText()}}&gt;
            </p>
        </div>

        <div class="row form-group">
            <label class="col-48 text-bold mb-1" for="select_element" translate>Default fix</label>
            <div class="col-48">
                <div class="d-flex align-items-center setting-container"
                     [class.active]="replacementSetting === 0"
                     (click)="setReplacementSetting(0)">
                    <p class="my-0 pr-3" translate>Replace all &lt;marquee&gt; tags with</p>
                    <div class="flex-fill">
                        <angular-selector
                                (change)="updatePreview()"
                                [required]="replacementSetting === 0"
                                [disabled]="replacementSetting !== 0"
                                labelAttr="name"
                                valueAttr="value"
                                [options]="elementOptions"
                                [(ngModel)]="elementReplacement"
                                [name]="'elementReplacement'"
                                monId="select_element">
                        </angular-selector>
                    </div>
                    <div class="flex-fill">
                        <span class="fas fa-question-circle fa-fw"
                              aria-hidden="true"
                              [ngbTooltip]="'Choose a tag to replace your marquee tags with' | translate"
                              triggers="focus hover"
                              placement="top-right">
                        </span>
                    </div>
                    <div class="pl-4 pt-1 pr-1">
                            <input type="radio"
                                   [attr.aria-label]="'Default fix' | translate"
                                   [(ngModel)]="replacementSetting"
                                   [value]="0"
                                   name="replacementSetting"/>
                    </div>
                </div>
            </div>
        </div>

        <p class="text-bold mb-1" translate>Custom settings</p>
        <div class="setting-container d-flex"
             [class.active]="replacementSetting === 1"
             (click)="setReplacementSetting(1)">
            <div class="flex-fill d-flex">
                <p class="my-0 align-self-center" *ngIf="replacementSetting !== 1">
                    <span translate>Choose this option to customize the fix</span><span class="fas fa-question-circle"
                          aria-hidden="true"
                          [ngbTooltip]="'Change <marquee> tags to a custom element' | translate"
                          triggers="focus hover"
                          placement="top-right">
                    </span>
                </p>
                <div class="row form-group mb-0" *ngIf="replacementSetting === 1">
                    <label class="col-48" for="custom_element">
                        <span translate>Change your &lt;marquee&gt; tags into something else</span><span class="fas fa-question-circle"
                              [ngbTooltip]="'Change <marquee> tags to a custom tag' | translate"
                              triggers="focus hover"
                              placement="top-right"
                              container="body"
                              aria-hidden="true">
                        </span>
                    </label>
                    <div class="col-24">
                        <input type="text"
                               [required]="replacementSetting === 1"
                               [pattern]="replacementRegex"
                               [attr.placeholder]="'Write custom tag' | translate"
                               class="form-control"
                               id="custom_element"
                               name="customElement"
                               [disabled]="replacementSetting !== 1"
                               (ngModelChange)="updatePreview()"
                               [(ngModel)]="customElement"/>
                        <div class="row">
                            <form-field-errors [input]="customElement"
                                               *ngIf="replacementSetting === 1"
                                               offset="0"
                                               [patternMsg]="'Element name is invalid' | translate">
                            </form-field-errors>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pl-4 pt-1 pr-1">
                <input type="radio"
                       [attr.aria-label]="'Custom settings' | translate"
                       [(ngModel)]="replacementSetting"
                       [value]="1"
                       name="replacementSetting"/>
            </div>
        </div>
    </div>
</form>
